app.directive('loadMasonry', ['$rootScope', function (rootScope) {
    return function (scope, element, attrs) {
        if (scope.$last) {
            var grid = jQuery('#container-dashboard .page-content').masonry({
                itemSelector: '.masonry-brick',
                gutter: 20
            });
            grid.masonry('layout');
        }
    };
}]
);